// ============================================
// KOMPLETNA PALETA KOLORÓW - FLEX MENU ADMIN
// ============================================
// KAŻDY kolor w aplikacji MUSI pochodzić z tego pliku
// Wartości to CSS variables ustawiane dynamicznie przez ThemeContextProvider

export const colors = {
  // ============ PRIMARY ============
  primary: 'var(--color-primary)',
  primaryHover: 'var(--color-primary-hover)',
  primaryLight: 'var(--color-primary-light)',
  primaryDark: 'var(--color-primary-dark)',

  // ============ SUCCESS/GREEN ============
  success: 'var(--color-success)',
  successHover: 'var(--color-success-hover)',
  successLight: 'var(--color-success-light)',
  successLighter: 'var(--color-success-lighter)',
  successDark: 'var(--color-success-dark)',
  successBackground: 'var(--color-success-bg)',

  // ============ ERROR/RED ============
  error: 'var(--color-error)',
  errorHover: 'var(--color-error-hover)',
  errorLight: 'var(--color-error-light)',
  errorLighter: 'var(--color-error-lighter)',
  errorDark: 'var(--color-error-dark)',
  errorBorder: 'var(--color-error-border)',
  errorBackground: 'var(--color-error-bg)',

  // ============ WARNING/ORANGE ============
  warning: 'var(--color-warning)',
  warningHover: 'var(--color-warning-hover)',
  warningLight: 'var(--color-warning-light)',
  warningDark: 'var(--color-warning-dark)',

  // ============ INFO/BLUE ============
  info: 'var(--color-info)',
  infoLight: 'var(--color-info-light)',
  infoDark: 'var(--color-info-dark)',

  // ============ TEXT ============
  textPrimary: 'var(--color-text)',
  textSecondary: 'var(--color-text-secondary)',
  textTertiary: 'var(--color-text-tertiary)',
  textDisabled: 'var(--color-text-disabled)',
  textWhite: 'var(--color-text-inverse)',
  textBlack: 'var(--color-text)',

  // ============ BORDERS ============
  border: 'var(--color-border)',
  borderLight: 'var(--color-border-light)',
  borderDark: 'var(--color-border-dark)',
  borderInput: 'var(--color-border-input)',
  borderHover: 'var(--color-border-hover)',

  // ============ BACKGROUNDS ============
  white: 'var(--color-surface)',
  backgroundLight: 'var(--color-background)',
  backgroundGray: 'var(--color-background-secondary)',
  backgroundDark: 'var(--color-background-tertiary)',
  backgroundOverlay: 'var(--color-overlay)',
  backgroundOverlayDark: 'var(--color-overlay-dark)',
  backgroundHover: 'var(--color-background-hover)',

  // ============ GRAY SCALE ============
  gray50: 'var(--color-gray-50)',
  gray100: 'var(--color-gray-100)',
  gray200: 'var(--color-gray-200)',
  gray300: 'var(--color-gray-300)',
  gray400: 'var(--color-gray-400)',
  gray500: 'var(--color-gray-500)',
  gray600: 'var(--color-gray-600)',
  gray700: 'var(--color-gray-700)',
  gray800: 'var(--color-gray-800)',
  gray900: 'var(--color-gray-900)',

  // ============ NEUTRAL COLORS ============
  neutral100: 'var(--color-gray-100)',
  neutral200: 'var(--color-gray-200)',
  neutral300: 'var(--color-gray-300)',
  neutral400: 'var(--color-gray-400)',
  neutral500: 'var(--color-gray-500)',
  neutral600: 'var(--color-gray-600)',
  neutral700: 'var(--color-gray-700)',
  neutral800: 'var(--color-gray-800)',
  neutral900: 'var(--color-gray-900)',

  // ============ SPECIFIC UI COLORS ============
  cardBorder: 'var(--color-border)',
  cardBackground: 'var(--color-surface)',
  cardShadow: 'var(--color-shadow-light)',

  // Input states
  inputBorder: 'var(--color-border-input)',
  inputBorderHover: 'var(--color-primary)',
  inputBorderFocus: 'var(--color-primary)',
  inputBackground: 'var(--color-surface)',
  inputDisabled: 'var(--color-input-disabled)',

  // Button states
  buttonPrimaryBg: 'var(--color-primary)',
  buttonPrimaryHover: 'var(--color-primary-hover)',
  buttonPrimaryActive: 'var(--color-primary-active)',
  buttonDefaultBg: 'var(--color-surface)',
  buttonDefaultBorder: 'var(--color-border)',
  buttonDefaultHover: 'var(--color-surface-hover)',

  // Ant Design colors (mapowane na semantyczne)
  antBlue: 'var(--color-info)',
  antGreen: 'var(--color-success)',
  antRed: 'var(--color-error)',
  antOrange: 'var(--color-warning)',
  antCyan: 'var(--color-info)',
};

// ============================================
// TYPOGRAPHY
// ============================================
export const typography = {
  // Titles
  pageTitle: {
    fontSize: '24px',
    fontWeight: 600,
    color: 'var(--color-text)',
  },
  sectionTitle: {
    fontSize: '16px',
    fontWeight: 600,
    color: 'var(--color-text)',
  },

  // Text
  label: {
    fontSize: '14px',
    fontWeight: 500,
    color: 'var(--color-text)',
  },
  body: {
    fontSize: '14px',
    fontWeight: 400,
    color: 'var(--color-text)',
  },
  description: {
    fontSize: '13px',
    fontWeight: 400,
    color: 'var(--color-text-secondary)',
  },
  caption: {
    fontSize: '12px',
    fontWeight: 400,
    color: 'var(--color-text-secondary)',
  },
};

// ============================================
// SPACING
// ============================================
export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '24px',
  xxl: '32px',
  xxxl: '40px',
};

// ============================================
// SIZES
// ============================================
export const sizes = {
  // Buttons
  buttonHeight: '40px',
  buttonHeightSmall: '32px',
  buttonHeightLarge: '48px',
  buttonHeightHold: '60px',

  // Inputs
  inputHeight: '32px',
  inputHeightLarge: '40px',
  inputHeightAuth: '48px',

  // Border radius
  borderRadius: '12px',
  borderRadiusSmall: '8px',
  borderRadiusLarge: '16px',
  borderRadiusCircle: '50%',

  // Layout
  headerHeight: '60px',
  sidebarWidth: '240px',
  sidebarCollapsedWidth: '80px',
};

// ============================================
// SHADOWS
// ============================================
export const shadows = {
  none: 'none',
  small: '0 1px 2px var(--color-shadow-light)',
  medium: '0 2px 8px var(--color-shadow)',
  large: '0 4px 12px var(--color-shadow)',
  xlarge: '0 8px 24px var(--color-shadow)',
  subtle: '0 -1px 8px var(--color-shadow)',

  // Focus shadows
  focus: '0 0 0 4px rgba(79, 70, 229, 0.1)',
  focusPrimary: '0 0 0 4px rgba(79, 70, 229, 0.1)',
  focusError: '0 0 0 4px rgba(220, 38, 38, 0.1)',

  // Button shadows
  button: '0 4px 15px rgba(79, 70, 229, 0.4)',
  buttonHover: '0 6px 20px rgba(79, 70, 229, 0.5)',

  // Card shadows
  card: '0 1px 2px var(--color-shadow-light)',
  cardHover: '0 2px 8px rgba(79, 70, 229, 0.15)',

  // Header/topbar shadow
  header: '0 2px 8px var(--color-shadow)',
};

// ============================================
// TRANSITIONS
// ============================================
export const transitions = {
  fast: '0.15s ease',
  normal: '0.2s ease',
  slow: '0.3s ease',
  allFast: 'all 0.15s ease',
  allNormal: 'all 0.2s ease',
  allSlow: 'all 0.3s ease',
};

// ============================================
// Z-INDEX
// ============================================
export const zIndex = {
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  modalBackdrop: 1040,
  modal: 1050,
  popover: 1060,
  tooltip: 1070,
};
